import { useMutation, useQueryClient } from '@tanstack/react-query';
import { api } from 'src/common/utils/api';

export default function useUnlinkMatch() {
  const queryClient = useQueryClient();

  return useMutation<unknown, Error, string>({
    mutationFn: (assetId: string) => api.post('connected-assets/matches/unlink', { assetId }),
    onSettled: () => {
      queryClient.invalidateQueries({ queryKey: ['connected-assets'] });
    },
  });
}
